<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter1">
<h1 class="left"><a href="#/004toc#january1">January 1</a></h1>
<p class="noindent">Your indecisiveness will prove to be your biggest shortcoming. When faced with a tough decision, such as whether to confront a horde of hungry zombies or retreat to a dark, windowless basement, remember that your first instinct is generally your best.</p>
<p class="indent"><em>Beware of:</em> Clowns with sharpened teeth</p>
<div class="image" id="image4">
<p class="center"><img alt="image 4" src="images/StarRule.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006chapter1.vue?1279595f